import React, {PureComponent} from 'react'
import PageHeaderWrapper from '../../../components/PageHeaderWrapper'
import {Button, Input, Row, Card, Form, notification, Popconfirm, Tabs, Tooltip} from 'antd'
import {TableComp, FormUtils as GetAllFormFields} from 'sz-react-utils'
import Request from '../../../request'
import styles from '../../Template/all/styles.less'
import moment from 'moment'
import {connect} from 'react-redux'
import _ from 'lodash'

import {getUrlPushWrapper} from '../../../routes'
import {hideLoader, showLoader} from '../../../modules/actions'
import {RightsWrapper} from '../../../components/_utils/utils'
import { Col } from 'antd/es/grid'
const TabPane = Tabs.TabPane

@Form.create()

class AllIvrSettings extends PureComponent {
  state = {
    id: '',
    total: 0,
    activeTab: '0',
    refreshChild: false,
    settings: [],
    settingTitles: {
      'searchApiUrl': 'Search Api Url',
      'searchApiToken': 'Api Token',
      'fetchUserApiUrl': 'Fetch User Api Url',
      'callApiUrl': 'Call Api Url',
      'callXApiToken': 'Call X-Api-Token',
      'companyId': 'Company Id',
      'secretToken': 'Secret Token',
      'type': 'Type',
      'publicIVRId': 'Public IVR Id',
    }
  }

  handleSubmit = e => {
    const {dispatch, form} = this.props
    e.preventDefault()
    form.validateFieldsAndScroll(async (err, valData) => {
      if (!err) {
        let values = _.clone(valData)
        let x = await Request.saveIVRSettings({values});
        if (!x.error) {
          notification.success({
            message: "Details Updated Successfully"
          })
        } else {
          notification.error({
            message: 'Error Saving',
            description: x.msg
          })
        }
      }
    })
  }
  callback = (value) => {
    if (value) {
      this.chooseTab(value)
    }
  }
  getIVRSettings() {
    Request.getIVRSettings().then(
      ({settings, error, message}) => {
        if (!error && settings) {          
          this.setState({settings: settings});  
          let $this = this;
          let tempObj = {}
          _.each(settings, (setting, k) => {
            tempObj[setting.settingKey] = setting.settingValue;
          })
          setTimeout(() => {
              this.props.form.setFieldsValue(tempObj)
          }, 10);
        } else {
          notification.error({
            message: 'Error Getting Data',
            description: message
          })
        }
      }
    )
  }
  refreshFxn = () => {
    this.setState({refreshChild: !this.state.refreshChild})
  }

  componentWillMount() {
  }

  async componentDidMount() {
    await this.getIVRSettings();
  }

  constructor(props) {
    super(props)
    this.table = React.createRef()
  }
  chooseTab(value) {
    this.setState({
      activeTab: value
    })
  }
  render() {
    const {dispatch} = this.props
    const {
      form: {getFieldDecorator, setFieldsValue}
    } = this.props
    const {settings, settingTitles} = this.state;
    let fields = [];
    settings && settings.map((setting, index) => {
      fields.push({
        label: settingTitles[setting.settingKey],
        key: setting.settingKey,
        type: 'text'
      });
    });    
    const inputTypes = {
      fields: fields
    };
    return (
      <PageHeaderWrapper title={` IVR Settings `}>
        <Card bordered={true}>
          <Form onSubmit={this.handleSubmit} style={{marginTop: 8}}>
            <GetAllFormFields
              inputSchema={inputTypes}
              refresh={this.refreshFxn}
              getFieldDecorator={getFieldDecorator}
            />
            <Button
              type=""
              htmlType="submit"
              style={{
                marginBottom: 10,
                marginLeft: '33%',
                backgroundColor: 'green',
                color: 'white'
              }}
              loading={this.props.loading}>
              SAVE
            </Button>
            <Button
              type="primary"
              style={{marginBottom: 10, marginLeft: '1%'}}
              loading={this.props.loading}
              onClick={() => {
                this.props.form.resetFields()
              }}>
              RESET
            </Button>
          </Form>
        </Card>
      </PageHeaderWrapper>
    );
  }
}
const mapStateToProps = ({global, router}) => ({
  loading: global.buttonLoading,
  categories: global.categories,
  search: router.location.search
})

const mapDispatchToProps = dispatch => {
  return {
      dispatch
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(AllIvrSettings)
